import MD5 from "crypto-js/md5";

export default function ProjectMD5({email, projectTitle, flowTitle, geoTitle, planTitle, flowFile, geoFile, planFile}) {
    let hash = `${email.trim()}${projectTitle.trim()}${planFile.trim()}${planTitle.trim()}${flowFile.trim()}${flowTitle.trim()}${geoFile.trim()}${geoTitle.trim()}`
    return MD5(hash).toString()
}